// stores/loading.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoadingStore = defineStore('loading', () => {
  const isLoading = ref(false);
  const requestCount = ref(0);
  let hideTimeout: number | null = null;

  // 延迟时间（毫秒）
  const HIDE_DELAY = 300;

  const showLoading = () => {
    // 如果有等待中的隐藏定时器，清除它
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    requestCount.value++;
    if (requestCount.value > 0) {
      isLoading.value = true;
    }
  };

  const hideLoading = () => {
    requestCount.value--;

    if (requestCount.value <= 0) {
      requestCount.value = 0;

      // 延迟隐藏，避免闪烁
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }

      hideTimeout = window.setTimeout(() => {
        isLoading.value = false;
        hideTimeout = null;
      }, HIDE_DELAY);
    }
  };

  const resetLoading = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
    requestCount.value = 0;
    isLoading.value = false;
  };

  return {
    isLoading,
    requestCount,
    showLoading,
    hideLoading,
    resetLoading,
  };
});
